<img
  [src]="path + imageUrl"
  [alt]="'PROGRESS_BAR.WRONG_ICON' | translate"
  data-testid="node-img" />
